import type { Locale } from "../locale";
import type { Dictionary } from "./types";
import { en } from "./en";
import { zhHant } from "./zh-Hant";
import { zhHans } from "./zh-Hans";
import { ja } from "./ja";

export const dictionaries: Record<Locale, Dictionary> = {
  en,
  "zh-Hant": zhHant,
  "zh-Hans": zhHans,
  ja
};

export type { Dictionary } from "./types";
